var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirPurifier = function SvgAirPurifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#air-purifier_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 10,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 7.801,
    y: 10.5,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 14.2 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 12.398 10.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.6,
    y: 11,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 12,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 7.801,
    y: 12.5,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 14.2 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 12.398 12.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.6,
    y: 13,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 6,
    y: 14,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 7.801,
    y: 14.5,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 14.2 14)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(-1 0 0 1 12.398 14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 9.6,
    y: 15,
    fill: "currentColor",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10 1.5c1.403 0 2.688.114 3.634.303.468.093.88.211 1.187.356.152.072.305.162.427.281.123.12.252.31.252.56s-.13.44-.252.56c-.122.119-.275.209-.427.28-.306.146-.719.264-1.187.357-.946.19-2.23.303-3.634.303s-2.688-.114-3.634-.303c-.468-.093-.88-.211-1.187-.356a1.6 1.6 0 0 1-.427-.281A.78.78 0 0 1 4.5 3c0-.25.13-.44.252-.56.122-.119.275-.209.427-.28.306-.146.719-.264 1.187-.357.946-.19 2.23-.303 3.634-.303ZM16.45 17.5a2.5 2.5 0 0 1-2.45 2H5.8a2.3 2.3 0 0 1-2.278-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.352,
    height: 1,
    x: 2.98,
    y: 17.947,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-86.012 2.98 17.947)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.352,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "scale(-1 1)rotate(-86.012 1.099 18.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 9,
    y: 6.5,
    fill: "currentColor",
    rx: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "air-purifier_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAirPurifier;